class DataURIConverter {
  // CanvasElement.toBlob isn't supported by Safari or Opera:
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
  // This solution stolen from:
  // http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
  static getBlobFromDataURI(dataURI, contentType) {
    return new Promise((resolve) => {
      const byteString = atob(dataURI.split(',')[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      resolve(new Blob([ab], { type: contentType }));
    });
  }
}

export default DataURIConverter;
